import React from 'react';
import { Helmet } from 'react-helmet-async';

import { __ADMIN__ } from '@vz/env';

import IPhone from '../../projects/iphone/page';

const IphonePage = () => (
  <>
    <Helmet>
      <title>Imageless iPhone 4 by Vasyl Zubach</title>
      <meta
        name="description"
        content="Imageless iPhone made with CSS by Vasyl Zubach. No images, base64, SVG, or canvas, just a lot of CSS and a little bit of JavaScript"
      />
    </Helmet>
    <section className="w-900">
      <IPhone />
    </section>
  </>
);

export default IphonePage;
